import {Badge, ChevronLeft, LinedRow, Typography} from '@kaman/uikit';
import {SmartImage} from '../../../components/images/SmartImage';
import type {
    IGetOfflineSearchSectionsResponse,
    IGetStoreProductsResponse,
} from '../../../models/store.model';

interface WideStoreProps {
    section?: IGetOfflineSearchSectionsResponse;
    store?: IGetStoreProductsResponse;
    onNavigate: (route?: string | null) => void;
}

function WideStoreRow({
    store,
    onNavigate,
    hasBottomBorder = true,
}: {
    store: IGetStoreProductsResponse;
    onNavigate: (route?: string | null) => void;
    hasBottomBorder?: boolean;
}) {
    return (
        <LinedRow
            hasBottomBorder={hasBottomBorder}
            className="cursor-pointer w-full "
            onClick={() => onNavigate(store.route)}
            rightSideIcon={
                <div
                    className="flex h-10 w-10 p-[4px] ml-2 items-center justify-center overflow-hidden rounded-[0.5rem]"
                    style={{
                        backgroundColor: store.backgroundColor ?? '#EDEDED',
                    }}
                >
                    {store.imageUrl ? (
                        <SmartImage
                            src={store.imageUrl}
                            alt={store.title}
                            size="100%"
                            borderRadius={8}
                            imageStyle={{
                                height: '32px',
                                width: '32px',
                                objectFit: 'contain',
                            }}
                        />
                    ) : null}
                </div>
            }
            rightSideNode={
                <div className="flex min-w-0 flex-col gap-1">
                    <Typography variant="h6" className="text-gray-900">
                        {store.title}
                    </Typography>
                    {store.description1 && (
                        <Typography variant="body-small" color="gray">
                            {store.description1}
                        </Typography>
                    )}
                </div>
            }
            leftSideNode={<ChevronLeft size={20} />}
        />
    );
}

export default function WideStore({
    section,
    store,
    onNavigate,
}: WideStoreProps) {
    if (store) {
        return <WideStoreRow store={store} onNavigate={onNavigate} />;
    }
    if (!section) return null;

    return (
        <>
            <LinedRow
                className="mb-0"
                hasBottomBorder={false}
                rightSideNode={
                    <Typography as="h2" variant="h6" className="text-gray-900">
                        {section.mainTitle}
                    </Typography>
                }
                leftSideNode={
                    section.caption ? (
                        <Badge
                            text={section.caption}
                            variant="outlined"
                            textColor="primary"
                            size="md"
                            className="border border-[#007AFF]"
                        />
                    ) : undefined
                }
            />

            <div className="flex w-full min-w-0 flex-col gap-2">
                {section.sectionItems?.map((store, itemIndex) => (
                    <WideStoreRow
                        key={`${store.route}-${store.title}-${itemIndex}`}
                        store={store}
                        onNavigate={onNavigate}
                    />
                ))}
            </div>
        </>
    );
}
